<template>
  <div>
    <v-app  v-if="!loggedin" >
      <v-app-bar app flat color="awesome" class="py-0" >
        <v-btn text to="/" class="white--text">
          <img src="@/assets/frontlogo2.png" height="40" class="pr-2"/> Textappy.io
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text class="white--text" to="/auth/signin">Sign In</v-btn>
        <v-btn outlined class="white--text" to="/auth/signup">Sign Up</v-btn>
      </v-app-bar>
      <RouterView />
      <Snackbar />
    </v-app>

    <v-app v-else>
      <BaseBtn icon fab fixed top right to="/" v-if="!authShow">
        <v-icon large>{{icons.home}}</v-icon>
      </BaseBtn>
      <v-navigation-drawer
              v-if="authShow && loggedin"
              v-model="drawer"
              app
              clipped
      >

        <v-list-item>
          <v-list-item-icon>
            <v-avatar tile>
              <img :src="logo" />
            </v-avatar>
          </v-list-item-icon>
        </v-list-item>


        <v-divider></v-divider>

        <v-list
                v-if="loggedin"
                dense
                nav
        >

          <v-list-item v-for="l in loggedinmenu"
                       :key="l.text"
                       :to="l.to" >
            <v-list-item-icon v-if="l.icon">
              <v-icon>{{icons[l.icon]}}</v-icon>
            </v-list-item-icon>
            <v-list-item-avatar v-if="l.imgsrc" size="24" tile>
              <v-img :src="l.imgsrc" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{l.text}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="org" :key="org.partkey" to="/organization">
            <v-list-item-avatar size="25">
              <v-img :src="org.info.small_logo" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Organization</v-list-item-title>
              <v-list-item-subtitle>{{org.info.fullname}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

        </v-list>
      </v-navigation-drawer>
      <v-app-bar color="awesome" dark app dense flat v-if="authShow">
        <v-app-bar-nav-icon @click="drawer=!drawer" ></v-app-bar-nav-icon>
        <v-toolbar-title class="headline text-uppercase">
          <span>TEXTAPPY</span>
          <span class="font-weight-light">.IO</span>
          <span class="ml-2" v-if="dev">{{$vuetify.breakpoint.name}}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <NoteBell class="mr-2" v-if="$store.state.notifications" />

        <NavMenue />

      </v-app-bar>

      <RouterView  />

      <Snackbar />

      <v-dialog v-model="registrationdialog">
        <v-card>
          <v-card-text>
            Update new content
          </v-card-text>
          <v-card-actions>
            <BaseBtn @click="w.location.reload(true);">Update</BaseBtn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-app>
  </div>
</template>

<script>
import BaseBtn from "@/components/BaseBtn";
import MenuItems from "@/menuitems.js"
import {
  mapState,
  mapActions
} from 'vuex'
import NavMenue from "./NavMenue";
export default {
  name: 'App',
  components: {
    NavMenue,
    BaseBtn,
    NoteBell: () => import('@/components/NoteBell'),
    Snackbar: () => import('@/components/Snackbar'),
  },
  computed:{
    ...mapState(['appdata','icons','loggedin','org','isReady','dev','globalredraw']),
    authShow(){
      return !this.$route.path.includes('auth')
    },
    logo(){
      return (this.org)?(this.org.info.small_logo||this.org.info.logo):'/img/icons/apple-touch-icon-60x60.png'
    },
    loggedinmenu(){
      return MenuItems
    }
  },
  watch:{
    loggedin(n,o){
      if(!n && this.$route.meta.protect){
        this.$router.push('/auth/signin?rd='+this.$route.path)
      }
      if(n && this.$route.query.rd){
        this.$router.push(this.$route.query.rd)
      }
    },
    $route(n,o){
      ///this is just a timer function..
      //if the page is refreshed, we allow the initial $store.getAppData function time to complete.
      //if at that time, we are still loggedout, then we will redirect...smoother for users
      //o0r else we will call the getAppData twice in a row, waisting resources..
      if(n.meta.protect && !this.loggedin){
        let em = this
        setTimeout(function(){
          em.checkAuth(n.meta.protect)
        },2000)
      }
    }
  },
  data: () => ({
    drawer:false,
    w:'',
    orgdialog:false,
    activeorg:false,
    registrationdialog:false,
    registration: null,
  }),
  mounted(){
    let em = this;
    em.w = window;
    this.drawer = (this.loggedin) ? this.$vuetify.breakpoint.lgAndUp : false
    document.addEventListener('swUpdated', this.showRefreshUI);
    document.addEventListener('offline', this.showOffline);
    // this.longPole()
    this.storageGroup()
    this.storageContact()
  },
  methods:{
    ...mapActions(['getAppData','post','refreshAuth']),
    checkAuth(protect){
      if(protect && !this.loggedin){
        this.refreshAuth()
        this.$router.push('/auth/signin?rd='+this.$route.path)
      }
    },
    storageGroup(){
      let g = window.localStorage.getItem('groups')
      if(g)this.$store.commit('setGroups', JSON.parse(g))
    },
    storageContact(){
      let c = window.localStorage.getItem('contacts')
      if(c)this.$store.commit('setContacts', JSON.parse(c))
    },
    async getIp(){
      let p = await fetch(this.url+'ip').then(async (response)=> {return await response.json()})
      window.localStorage.setItem('ip',p.ip)
    },
    showOffline(){
      console.log('Offline')
    },
    showRefreshUI (e) {
      this.$store.commit('setNewContent',true)
      // My code to show the refresh UI banner/snackbar goes here.
    },
    refreshGo(){
    },
    longPole(){
      let em = this;
      setTimeout(function(){
        em.getAppData();
        em.longPole()
        console.log('longpole');
      },10000)
    }
  },
  beforeDestroy () {
    document.removeEventListener('swUpdated', this.showRefreshUI);
  }
};
</script>
